import styled from "@emotion/styled";
import { Content } from "src/atoms/Content";
import { StyledSkeleton } from "src/molecules/BrandCover/BrandCover.styled";

export const ContentContainer = styled(Content)`
  display: grid;
  grid-template-columns: 100%;
  row-gap: ${({ theme }) => theme.space?.space24};
  padding-bottom: ${({ theme }) => theme.space?.space32};
  min-width: 0;
  min-height: 100vh;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space?.space24};
`;

export const HeaderSkeleton = styled(StyledSkeleton)`
  height: 480px;

  @media (max-width: ${({ theme }) => theme.breakpoints?.sm}) {
    height: 300px;
  }
`;

export const PromoWrapper = styled.div`
  position: relative;
  grid-column: span 3;
  display: grid;
  grid-template-rows: ${({ theme }) =>
    `minmax(${
      (theme.space?.space96 || "") +
      (theme.space?.space64 || "") +
      (theme.space?.space24 || "")
    }, 1fr)`};
  transition: all 250ms ease-in-out;
  gap: ${({ theme }) => theme.space.space24};
`;
